module.exports = __webpack_public_path__ + "res/Roboto-Thin-webfont.svg?622a084861c324b0442f915395479f36";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Thin-webfont.svg
// module id = 60
// module chunks = 0